<div class="header">
    <h1>Add Fuel Expense</h1>
    <button mat-dialog-close>
        <img src="../../../../assets/images/svg/closeBtn.svg" alt="" srcset="">
    </button>
</div>
<div class="scrollHeightDialog">
    <div class="row m-0 py-4">
        <div class="col-xl-11 mx-auto">
            <div class="row">
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label for="">Fuel Pump</label>
                        <select name="" class="form-control form-select "id="">
                            <option value="">Fuel Pump</option>
                        </select>
                    </div>
                </div>
                <div class="col-xl-4 mb-3">
                    <div class="form-group">
                        <label for="">Date of Expenses</label>
                        <input type="date" class="form-control" />
                    </div>
                </div>
                <div class="col-xl-4 mb-3">
                    <div class="form-group">
                        <label for="">Fuel Expense Amount</label>
                        <input type="text" class="form-control" />
                    </div>
                </div>
                <div class="col-xl-4 mb-3">
                    <div class="form-group">
                        <label for="">Payment Mode</label>
                        <select name="" class="form-control form-select "id="">
                            <option value="">Fuel Pump</option>
                        </select>
                    </div>
                </div>
                <div class="col-xl-4 mb-3">
                    <div class="form-group">
                        <label for="">Fuel Quantity</label>
                        <input type="text" class="form-control" />
                    </div>
                </div>
                <div class="col-xl-4 mb-3">
                    <div class="form-group">
                        <label for="">Unit</label>
                        <select name="" class="form-control form-select "id="">
                            <option value="">Fuel Pump</option>
                        </select>
                    </div>
                </div>
                <div class="col-xl-4 mb-3">
                    <div class="form-group">
                        <label for="">Fuel Type</label>
                        <select name="" class="form-control form-select "id="">
                            <option value="">Fuel Pump</option>
                        </select>
                    </div>
                </div>
                <div class="col-xl-12 mb-3">
                    <div class="form-group">
                        <label for="">Driver Name</label>
                        <input type="text" class="form-control" name="" id="">
                    </div>
                </div>
                <div class="col-xl-12">
                    <div class="form-group accountsinp  mb-3">
                        <label for="">POD Image</label>
                        <div class="d-flex align-items-center gap-3 podimgbox">
                            <input type="file" id="podImagectrl" hidden formControlName="podImage"  accept="image/*,.pdf,.doc"   >
                            <!-- <button (click)="addPODFile()" mat-raised-button matTooltip="Upload"
                                                    class="btn btn-dark ms-2" type="submit"><i
                                                        class="fa-solid fa-upload"></i></button>
                                                        <a #showDoc [href]="docURL" target="_blank"></a> -->
                            <label for="podImagectrl">Choose File</label>
                            <p>No File Choosen</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 mb-3">
                    <div class="row">
                        <div class="col-xl-3 text-center">
                            <img src="../../../../assets/images/svg/podimg.svg" class="img-fluid w-100 mb-3" alt="">
                            <p>POD Image</p>
                        </div>
    
                    </div>
                </div>
                <div class="col-xl-12 text-center">
                    <button class="btn btn-dark py-2 px-5"
                    mat-raised-button >Submit</button>
                </div>
            </div>
        </div>
    </div>
</div>
